import BlankSlate from "@pathwright/ui/src/components/blank/BlankSlate"
import Button from "@pathwright/ui/src/components/button/Button"
import CohortShareIslandBackgroundTaskContextProvider from "@pathwright/web/src/modules/cohort/CohortShareIslandBackgroundTaskContextProvider"
import {
  ENROLLMENT_ROLE_FACILITATOR,
  ENROLLMENT_ROLE_STUDENT,
  ENROLLMENT_ROLE_TEACHER,
  ROLE_LABELS,
  ROLE_TYPE_OFFERING
} from "@pathwright/web/src/modules/invitation/constants"
import { ShareDumb } from "@pathwright/web/src/modules/share/Share"
import { ConnectStores } from "lib/core/store"
import * as urls from "lib/core/utils/urls"
import { forwardRef } from "react"

const INVITE_URLS_MAP = {
  [ENROLLMENT_ROLE_STUDENT]: "student",
  [ENROLLMENT_ROLE_FACILITATOR]: "moderator",
  [ENROLLMENT_ROLE_TEACHER]: "teacher"
}

const MemberListShareTrigger = forwardRef(({ title, icon, onToggle }, ref) => (
  <Button
    ref={ref}
    styleType="primary"
    brand
    preIcon={icon}
    label={title}
    onClick={onToggle}
  />
))

const MemberListEmpty = forwardRef((props, ref) => {
  const {
    resource,
    lastQuery,
    isCurriculum,
    toNewGroup,
    toInvite,
    role_type,
    offering,
    // share trigger props
    title,
    icon,
    onToggle
  } = props

  if (lastQuery && lastQuery.length) {
    return <BlankSlate body={`No results for "${lastQuery}"`} />
  } else if (isCurriculum) {
    if (resource.num_offerings === 0) {
      return (
        <BlankSlate
          heading="Ready to teach?"
          body="Create your first group to invite students."
          primaryAction={{
            children: "Create new group",
            to: toNewGroup
          }}
        />
      )
    }
  } else {
    return role_type ? (
      offering &&
      offering.invite_urls &&
      offering.invite_urls[INVITE_URLS_MAP[role_type]] ? (
        <BlankSlate
          heading={`There are no ${ROLE_LABELS[ROLE_TYPE_OFFERING][role_type]}s here yet.`}
          body="This is where you'll see progress and control access for everyone taking this course."
        >
          <MemberListShareTrigger
            title={title}
            icon={icon}
            onToggle={onToggle}
          />
        </BlankSlate>
      ) : (
        <BlankSlate
          heading={`There are no ${ROLE_LABELS[ROLE_TYPE_OFFERING][role_type]}s here yet.`}
        />
      )
    ) : (
      <BlankSlate
        heading="There's no one here yet."
        body="This is where you'll see progress and control access for everyone taking this course."
      >
        <MemberListShareTrigger title={title} icon={icon} onToggle={onToggle} />
      </BlankSlate>
    )
  }
})

MemberListEmpty.displayName = "MemberListEmpty"

const mapStateToProps = (state, ownProps) => {
  const { resource, offering, section } = state.resourceStore.state
  const { role_type } = state.memberStore.state
  const { getLastMemberQuery } = state.memberStore.request

  const lastQuery = getLastMemberQuery()
  const isCurriculum = offering && offering.is_curriculum
  const toNewGroup = urls.modalRoute(
    `/manage/resource/${resource && resource.id}/group/new/`
  )
  const toInvite = `${offering && offering.url}${section}/member/invite/`

  return _.assign(
    {},
    {
      resource,
      lastQuery,
      isCurriculum,
      toNewGroup,
      toInvite,
      role_type,
      offering
    },
    ownProps
  )
}

const stores = [
  { store: "resource", watch: ["resource", "offering", "section"] },
  { store: "member", watch: ["members", "role_type"] }
]

function MemberListEmptyContainer(props) {
  return props.resource && props.offering ? (
    <CohortShareIslandBackgroundTaskContextProvider
      resourceId={props.resource.id}
      cohortId={props.offering.id}
    >
      <ShareDumb
        context={{ type: "cohort", typeId: props.offering.id }}
        displayType="modal"
        triggerLabel="Invite someone"
      >
        {({ renderTrigger }) => renderTrigger(MemberListEmpty, props)}
      </ShareDumb>
    </CohortShareIslandBackgroundTaskContextProvider>
  ) : null
}

MemberListEmptyContainer.displayName = "MemberListEmptyContainer"

export default ConnectStores(
  MemberListEmptyContainer,
  stores,
  {},
  mapStateToProps
)
